module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18320/js/img/valuePropModals/ReportBuilder/ValueProp1.svg"